@if (vm$ | async; as vm) {
    <div class="h-full flex flex-col justify-between">
        <div class="p-2 flex flex-col gap-2 grow overflow-auto">
            @for (field of registerFields$ | async; track field.fieldId) {
                @if (hasTree(field.fieldId)) {
                    <cat-facet-tree-item [level]="0"
                                         (checkFacet)="onCheckFacet($event, field)"
                                         (expand)="onExpand(field, $event)"
                                         (collapse)="onCollapse(field, $event)"
                                         [coreId]="searchItem.coreId" [field]="field"
                                         [expandedFacetTreeNodes]="vm.expandedFacetTreeNodes"
                                         [item]="store.selectFacet(field.fieldId) | async"></cat-facet-tree-item>
                }
            }
        </div>
      <div class="p-2 border-top flex justify-center items-center">
            <button (click)="onSearch()" [loading]="loading$ | async" mat-flat-button>
                <mat-icon>search</mat-icon>
                {{ facetItem?.treeResultCount }}
            </button>
        </div>
    </div>
}
